module.exports = __webpack_public_path__ + "img/GPay.ecf0c349.svg";